import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import Tooltip from "components/Inputs/Tooltip";
import styles from "./style.module.css";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { isOptionType } from "utils/select";
import { isEnabled } from "utils/featureFlags";
const ModelSelector = ({ menuPlacement, className, isDisabled, hideIcons, modelId, updateModelId, forceModelId, isNewChat, isDynamic, isStyled, selectorStyle, color, onChange, isCreatable, style, ...retProps } = {}) => {
    const dispatch = useDispatch();
    const stateModelId = useSelector((state) => chatGPTReducer.getModelId(state));
    // If forceModelId, use the raw value of modelId
    const foundModelId = useSelector((state) => forceModelId ? modelId : (chatGPTReducer.getModelExternalId(state, modelId ?? stateModelId) ?? stateModelId));
    updateModelId = updateModelId ?? ((newId) => dispatch(chatGPTReducer.updateModelId(newId)));
    const modelOptions = useSelector((state) => chatGPTReducer.getModelOptions(state, undefined, undefined, isEnabled("provisioned-models-filter-interns")));
    // forceModelId allows the selectedModel to be undefined, showing the placeholder
    const selectedModel = forceModelId && !modelId
        ? undefined
        : (modelOptions.find((o) => o.value === foundModelId) ?? {
            value: foundModelId,
            label: foundModelId
        });
    const ModelOption = (props) => (React.createElement(CustomOption, { data: props.data, innerProps: props.innerProps, hideIcons: hideIcons, isNewChat: isNewChat, isStyled: isStyled, color: color }));
    const ModelValue = (props) => (React.createElement(CustomOption, { data: props.data, innerProps: props.innerProps, hideIcons: hideIcons, isCustomValue: true, isNewChat: isNewChat, isNewSingleValue: isNewChat, isStyled: isStyled, color: color }));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "chat-model-select", className: styles.modelSelector + " " + (className ? className : ""), style: style, ...retProps },
            React.createElement(DynamicWidthSelector, { options: modelOptions, value: selectedModel, onChange: (val) => {
                    if (isOptionType(val)) {
                        updateModelId(val?.value);
                    }
                    if (onChange) {
                        onChange(val);
                    }
                }, components: {
                    Option: ModelOption,
                    SingleValue: ModelValue
                }, placeholder: "Select AI Model", menuPlacement: menuPlacement ?? "bottom", isDisabled: isDisabled, isSearchable: true, isDynamic: isDynamic, isNewChat: isNewChat, isStyled: isStyled, style: selectorStyle, color: color, isCreatable: isCreatable }))));
};
export default ModelSelector;
const CustomOption = (props) => {
    const { innerProps, data, isCustomValue, isNewChat, isNewSingleValue, isStyled, hideIcons, color } = props;
    const [isHover, updateIsHover] = useState(false);
    const modelLabel = data?.label;
    const modelIcons = data?.icons;
    const retHideIcons = hideIcons || isCustomValue;
    return (React.createElement("div", { className: styles.modelSelectOption + " " + (isCustomValue ? styles.isValue : "") + " " + (isStyled ? styles.isStyled : ""), ...innerProps, onMouseEnter: () => {
            updateIsHover(true);
        }, onMouseLeave: () => {
            updateIsHover(false);
        } },
        React.createElement("div", { className: styles.modelSelectOptionLabel +
                " " +
                (isCustomValue ? styles.isValue : "") +
                " " +
                (isNewChat ? styles.isNewChat : "") +
                " " +
                (isNewSingleValue ? styles.isNewSingleValue : "") +
                " " +
                (isStyled ? styles.isStyled : ""), style: {
                color: isCustomValue ? color : "",
                borderColor: isHover && isCustomValue ? color : ""
            } }, modelLabel),
        !retHideIcons && modelIcons?.length > 0 && (React.createElement("div", { className: styles.modelSelectOptionIcons }, modelIcons.map((currIcon, i) => {
            return (React.createElement(Tooltip, { key: modelLabel + "icon" + i, trigger: ["hover"], overlay: React.createElement("div", null, currIcon.label) },
                React.createElement("div", { className: styles.modelSelectOptionIcon + " " + (isNewChat ? styles.isNewChat : "") },
                    React.createElement("img", { className: styles.modelSelectOptionIconDefault, src: currIcon.image }),
                    React.createElement("img", { className: styles.modelSelectOptionIconActive, src: currIcon.imageActive }))));
        })))));
};
